import { FileText } from "lucide-react"
import { Button } from "../../shadcn/button"

interface ModalFooterProps {
  onClose: () => void;
  showGenerateReport?: boolean;
  hasError?: boolean;
  onGenerateReport?: () => void;
}

const ModalFooter = ({ 
  onClose, 
  hasError = false
}: ModalFooterProps) => {
  return (
    <div className="flex justify-end gap-2 p-4 sm:p-6 border-t dark:border-neutral-700 bg-muted/20 dark:bg-neutral-800/50">
      
      <Button 
        variant={hasError ? "default" : "secondary"} 
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="min-w-24 bg-primary"
      >
        Fermer
      </Button>
    </div>
  )
}

export default ModalFooter